import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";

const Contact = () => {
    document.title = "DirtMap - Contact";
    const history = useHistory();
    const [contactInput, setContactInput] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        user_id: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0,
        error_list: [],
    })
    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const handleInput = (e) => {
        e.persist();
        setContactInput({ ...contactInput, [e.target.name]: e.target.value });
    }

    const submitContact = (e) => {
        showLoader();
        e.preventDefault();
        const data = {
            name: contactInput.name,
            email: contactInput.email,
            phone: contactInput.phone,
            user_id: contactInput.user_id,
            message: contactInput.message,
        }
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post(`/api/contact`, data).then(res => {
                if (res.data.success === true) {
                    hideLoader();
                    swal("success", "Contact Created Sucessfully Done", "success");
                    history.push('/contact');
                }
                else {
                    hideLoader();
                    setContactInput({ ...contactInput, error_list: res.data.errors });
                }
            });
        });
    }

    return (

        <div>
            <section className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 bread-crumb">
                            <Link to="/">Home</Link><span>&gt;</span>Contact
                        </div>
                    </div>
                </div>
                <hr />
            </section>
            <section className="contentContainer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2>Contact DirtMap</h2>
                            {/* <p>This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean , lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non  mauris vitae erat.</p>
                            <p>Consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit. Sed ut imperdiet nisi. Proin condimentum fermentum nunc. Etiam pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Suspendisse in orci enim.</p> */}
                            <form onSubmit={submitContact} className="questionForm contactForm __web-inspector-hide-shortcut__">
                            <input type="hidden" name="user_id" onChange={handleInput} value={contactInput.user_id}  />

                                <div className="row">
                                    <div className="col-md-6 col-sm-6">
                                        <input className="form-control textDesign txtHeight" type="text" name="name" id="name" onChange={handleInput} value={contactInput.name} placeholder="Name" maxLength={191} />
                                        <span className="validate-error-message">{contactInput.error_list.name}</span>

                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <input className="form-control textDesign txtHeight" type="text" name="email" id="email" onChange={handleInput} value={contactInput.email} placeholder="Email" maxLength={191} />
                                        <span className="validate-error-message">{contactInput.error_list.email}</span>

                                    </div>
                                    <div className="clearfix" />
                                    <div className="col-md-4 col-sm-4">
                                        <input className="form-control textDesign txtHeight" type="text" name="phone" id="phone" onChange={handleInput} value={contactInput.phone} placeholder="Cell" maxLength={191} />
                                        <span className="validate-error-message">{contactInput.error_list.phone}</span>
                                    </div>
                                    <div className="col-md-8 col-sm-8">
                                        <select className="form-control textDesign contact-query-type" name="query_type" onChange={handleInput} value={contactInput.query_type}>
                                            <option value="">Query Type</option>
                                            <option value="Reset my password">Reset my password</option>
                                            <option value="Give a compliment, suggestions & general feedback">Give a compliment, suggestions &amp; general feedback</option>
                                            <option value="Lodge a Complaint or frustration">Lodge a Complaint or frustration</option>
                                            <option value="Update My Contact Details">Update My Contact Details</option>
                                        </select>
                                        <span className="validate-error-message">{contactInput.error_list.query_type}</span>

                                        <span className="text-danger" />
                                    </div>
                                    <div className="clearfix" />
                                    <div className="col-md-12 col-sm-12">
                                        <textarea className="form-control textDesign txtArea" name="message" id="message" placeholder="Message" rows={3} onChange={handleInput} value={contactInput.message} />
                                        <span className="validate-error-message">{contactInput.error_list.message}</span>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="labelBox">&nbsp;</div>
                                        <div className="inputField">
                                            <input type="submit" className="button customButton01 active submitButton pull-right" />
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>
            {loader}
        </div>
    )
}

export default Contact;